<template>
    <div class="cc-dismiss">
        <div v-for="(reason, index) in rows" :key="reason.reason" class="cc-dismiss__row">
            <div class="cc-dismiss__label">{{ reason.reason }}</div>
            <div class="cc-dismiss__track">
                <div class="cc-dismiss__bar" :style="`width: ${reason.widthPercent}%; background: ${index === 0 ? '#424242' : '#a8a8a8'};`"></div>
            </div>
            <div class="cc-dismiss__share">{{ reason.sharePercent }}%</div>
        </div>

        <div class="cc-dismiss__footnote">Fed back from Veeva · % of {{ totalDismissals }} dismissals</div>
    </div>
</template>

<script>
export default {
    name: "CommandCenterDismissReasons",

    props: {
        // [{ reason, dismissals, share }], most frequent first.
        reasons: {
            type: Array,
            required: true,
        },
    },

    computed: {
        // Bars are scaled to the most frequent reason so the differences between them stay readable.
        rows() {
            const maxShare = Math.max(0, ...this.reasons.map((reason) => Number(reason.share) || 0));
            return this.reasons.map((reason) => {
                const share = Number(reason.share) || 0;
                return {
                    ...reason,
                    sharePercent: Math.round(share * 100),
                    widthPercent: maxShare > 0 ? (share / maxShare) * 100 : 0,
                };
            });
        },

        totalDismissals() {
            return this.reasons.reduce((sum, reason) => sum + (Number(reason.dismissals) || 0), 0);
        },
    },
};
</script>

<style scoped>
.cc-dismiss {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.cc-dismiss__row {
    display: flex;
    align-items: center;
    padding: 5px 0;
    font-size: 11px;
}

.cc-dismiss__label {
    width: 42%;
    padding-right: 8px;
    overflow: hidden;
    color: #262626;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.cc-dismiss__track {
    flex: 1;
    height: 12px;
}

.cc-dismiss__bar {
    height: 100%;
    transition: width 0.3s ease-in-out;
}

.cc-dismiss__share {
    width: 44px;
    color: #262626;
    font-weight: 700;
    text-align: right;
}

.cc-dismiss__footnote {
    margin-top: 6px;
    color: #9f9f9f;
    font-size: 10px;
}
</style>
